import React, { createContext, useState } from 'react';

const Context = createContext();
const SessionProvider = ({ children }) => {
    //ASIGNAMOS UN VALOR INICIAL
    const [ initialUser ] = useState({ Token: '', Nombre: '', Usuario: '', Sucursal: '' });
    const [ initialMenu ] = useState({ HISTORIAL: false, ALTAS: false });
    const [ initialHide ] = useState(true);
    const [ initialSelected ] = useState({IdRegistro: ''});

    //BUSCAMOS SI TENEMOS ESTE VALOR EN LOCAL STORAGE
    const getUser = localStorage.getItem('user');
    const getMenu = localStorage.getItem('menu');
    const getHide = localStorage.getItem('hide');
    const getSelected = localStorage.getItem('selected')

    //LO PASAMOS A JSON
    const localState = JSON.parse(getUser);
    const localMenu = JSON.parse(getMenu);
    const localHide = JSON.parse(getHide);
    const localSelected = JSON.parse(getSelected);

    //SI HABÍA UN VALOR EN LOCAL STORAGE LO TOMAMOS DE LO CONTRARIO TOMAMOS EL VALOR INICIAL
    const [user, setUser] = useState(localState || initialUser);
    const [menu, setMenu] = useState(localMenu || initialMenu);
    const [hide, setHide] = useState(localHide || initialHide);
    const [selected, setSelected] = useState(localSelected || initialSelected);

    //ASIGNAMOS LOS VALORES DE LA SESIÓN
    const login = ({ Token, Nombre, Usuario, Sucursal }) => {
        setUser({...user, Token, Nombre, Usuario, Sucursal });
    }

    //LIMPIAMOS LOS VALORES DE LA SESIÓN
    const logout = () => {
        localStorage.removeItem('user');
        setUser(initialUser);  
    }


    const mostrar = () => {
        setHide(false);
    }

    const ocultar = () => {
        localStorage.removeItem('hide');
        setHide(true);
    }

    const marcarMenu = (menu) => {
        setMenu(menu);
    }

    const desmarcarMenu = () => {
        localStorage.removeItem('menu');
        setMenu(initialMenu);
    }

    const seleccionar = (select) => {
        setSelected(select);
    }

    const deseleccionar = () => {
        localStorage.removeItem("selected");
        setSelected(initialSelected);
    }


    //GUARDAMOS EN UN OBJETO PARA PASARLO COMO PARÁMETRO
    const values = { user, setUser, logout, login, menu, marcarMenu, desmarcarMenu, hide, mostrar, ocultar, selected, seleccionar, deseleccionar };

    //GUARDAMOS LA SESIÓN EN LOCAL STORAGE
    React.useEffect(() => {
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("menu", JSON.stringify(menu));
        localStorage.setItem("hide", JSON.stringify(hide));
        localStorage.setItem("selected", JSON.stringify(selected));
    },[user, menu, hide, selected]);
    
    return (
        <Context.Provider value={ values }>
            { children }
        </Context.Provider>
    );
}

export default Context;
export { SessionProvider };